<script setup lang="ts">
defineProps<{
  offerCode: string
  copyCode: () => void | Promise<void>
  connectionMode?: 'internet' | 'local'
}>()

defineEmits<{
  'open-qr-modal': [code: string]
}>()
</script>

<template>
  <div class="flex flex-col items-center justify-center min-h-screen p-6">
    <div class="glass rounded-3xl p-6 max-w-md w-full text-center animate-fade-in">
      <h2 class="text-2xl font-bold text-white mb-4">📱 Esperando al Host</h2>

      <!-- Modo Local: Mostrar QR code -->
      <template v-if="connectionMode === 'local'">
        <p class="text-teal-200 mb-6">Muestra este código QR al host para conectar:</p>

        <div
          id="guest-qr-code"
          @click="$emit('open-qr-modal', offerCode)"
          class="flex justify-center mb-4 bg-white p-3 rounded-xl inline-block cursor-pointer hover:scale-105 transition-transform"
        ></div>

        <div class="mb-6">
          <button @click="copyCode" class="text-sm text-teal-200 underline mb-3">Copiar código</button>
          <p class="text-xs text-teal-300">El host debe escanear este QR o pegar el código de arriba</p>
        </div>

        <div class="bg-white/10 rounded-xl p-4 mb-4">
          <p class="text-teal-200 text-sm">Tu código:</p>
          <p class="text-xs text-white break-all font-mono mt-2 select-all">{{ offerCode.slice(0, 50) }}...</p>
        </div>

        <div class="text-left bg-white/5 rounded-xl p-4">
          <p class="text-teal-200 text-sm font-semibold mb-2">📋 Instrucciones:</p>
          <ol class="text-teal-200 text-xs space-y-1 list-decimal list-inside">
            <li>El host escanea este QR</li>
            <li>O copia este código y envíalo al host</li>
            <li>El host te añadirá a la partida</li>
          </ol>
        </div>
      </template>

      <!-- Modo Internet: Mensaje de espera sin QR -->
      <template v-else>
        <div class="mb-8">
          <div class="text-6xl mb-4 animate-pulse">⏳</div>
          <p class="text-teal-200 mb-2">Tu respuesta ha sido enviada al host</p>
          <p class="text-white/70 text-sm">Esperando que el host acepte la conexión...</p>
        </div>

        <div class="text-left bg-white/5 rounded-xl p-4">
          <p class="text-teal-200 text-sm font-semibold mb-2">📋 ¿Qué está pasando?</p>
          <ol class="text-teal-200 text-xs space-y-1 list-decimal list-inside">
            <li>Escaneaste el QR del host correctamente</li>
            <li>Tu respuesta fue enviada automáticamente</li>
            <li>El host te aceptará en unos segundos</li>
            <li>¡Serás redirigido a la sala automáticamente!</li>
          </ol>
        </div>
      </template>
    </div>
  </div>
</template>
